module.exports = __webpack_public_path__ + "img/symbols.832eca6d.svg";